var projectTimeline = {
	"Project timeline": "Cronograma do projeto",
	"None planned": "Nada planejado",
	"1-3 months": "1 a 3 meses",
	"4-6 months": "4 a 6 meses",
	"7-12 months": "7 a 12 meses",
	"More than 1 year": "Mais de um ano"
};

export { projectTimeline as default };
